/* Ordered, evenly spaced Ombre colours shared by both renderers. */
window.VA_OMBRE = {
 stops: c => c.gradientStops || [c.body, c.side],
 index: (c, id) => id==='body'?0:id==='side'?VA_OMBRE.stops(c).length-1:/^stop\d+$/.test(id)?Number(id.slice(4)):-1,
 get: (c,id) => {const i=VA_OMBRE.index(c,id);return i<0?c[id]:VA_OMBRE.stops(c)[i];},
 assign(c,stops){c.gradientStops=[...stops];c.body=stops[0];c.side=stops[stops.length-1];},
 set(c,id,hex){const i=this.index(c,id);if(i<0)c[id]=hex;else{const stops=[...this.stops(c)];stops[i]=hex;this.assign(c,stops);}},
 areas(c){return this.stops(c).map((_,i,a)=>[i===0?'body':i===a.length-1?'side':'stop'+i,i===0?'Top colour':i===a.length-1?'Bottom colour':'Gradient colour '+(i+1)]);},
 sample(stops,t){const a=stops.map(h=>h.match(/\w\w/g).map(x=>parseInt(x,16))),v=Math.max(0,Math.min(1,t))*(a.length-1),i=Math.min(a.length-2,Math.floor(v)),f=v-i;return a[i].map((x,k)=>x+(a[i+1][k]-x)*f);},
 mount(host,get,onchange){
  host.className='gradient-tools';host.setAttribute('role','group');host.setAttribute('aria-label','Ombre gradient order');
  const caption=document.createElement('p');caption.textContent='Gradient · top to bottom · 2–6 colours';host.append(caption);
  const buttons=[['add','Add colour'],['up','Move up'],['down','Move down'],['remove','Remove colour']].map(([action,label])=>{const b=document.createElement('button');b.type='button';b.dataset.gradientAction=action;b.textContent=label;host.append(b);b.onclick=()=>{const {colours,area}=get(),a=[...this.stops(colours)];let i=this.index(colours,area);if(action==='add'){i=a.length-1;a.splice(i,0,a[i]);}else if(action==='remove'){a.splice(i,1);i=Math.min(i,a.length-1);}else{const j=i+(action==='up'?-1:1);[a[i],a[j]]=[a[j],a[i]];i=j;}this.assign(colours,a);onchange(i===0?'body':i===a.length-1?'side':'stop'+i);const next=host.querySelector('[data-gradient-action="'+action+'"]');(next.disabled?buttons.find(b=>!b.disabled):next)?.focus({preventScroll:true});};return b;});
  return ()=>{const {colours,area,ombre,disabled}=get(),a=this.stops(colours),i=this.index(colours,area);host.hidden=!ombre;buttons[0].disabled=disabled||a.length>=6;buttons[1].disabled=disabled||i<=0;buttons[2].disabled=disabled||i<0||i>=a.length-1;buttons[3].disabled=disabled||i<0||a.length<=2;};
 }
};
/* One to three stripe colours, top band first. `side` always mirrors the first band. */
window.VA_STRIPE = {
 max: 3,
 colours: c => c.stripeColours && c.stripeColours.length ? c.stripeColours : [c.side],
 index: id => id === 'side' ? 0 : /^stripe[23]$/.test(id) ? Number(id.slice(6)) - 1 : -1,
 get(c, id) { const i = this.index(id); return i < 0 ? c[id] : this.colours(c)[i]; },
 assign(c, list) { c.stripeColours = [...list]; c.side = list[0]; },
 set(c, id, hex) { const i = this.index(id); if (i < 0) { c[id] = hex; return; } const list = [...this.colours(c)]; list[i] = hex; this.assign(c, list); },
 areas(c) { const list = this.colours(c); return list.map((_, i) => [i === 0 ? 'side' : 'stripe' + (i + 1), list.length === 1 ? 'Stripe' : 'Stripe colour ' + (i + 1)]); },
};
/* Colour of any selectable part, whichever style owns it. */
window.VA_PARTS = {
 get: (style, c, id) => style === 'ombre' ? VA_OMBRE.get(c, id) : style === 'stripe' ? VA_STRIPE.get(c, id) : c[id],
 set(style, c, id, hex) {
  if (style === 'ombre' && id === 'panels') { c.panels = hex; c.panelMode = 'solid'; }
  else if (style === 'ombre') VA_OMBRE.set(c, id, hex);
  else if (style === 'stripe') VA_STRIPE.set(c, id, hex);
  else c[id] = hex;
 },
 fadePanels: (style, c) => style === 'ombre' && c.panelMode !== 'solid',
 outlined: c => c.logoStyle !== 'solid',
};
/* Design settings shown above the colour chips for the selected part: logo style, Ombre panel
   fade, stripe placement and colour count. Client requests, 14 Sep 2026. Shared by both builders. */
window.VA_OPTIONS = {
 mount(host, get, onchange) {
  host.className = 'option-tools';
  function group(label, buttons) {
   const g = document.createElement('div'); g.className = 'option-tools__group'; g.setAttribute('role', 'group'); g.setAttribute('aria-label', label);
   const p = document.createElement('p'); p.textContent = label; g.append(p);
   for (const [key, text, handler] of buttons) {
    const b = document.createElement('button'); b.type = 'button'; b.dataset.option = key; b.textContent = text;
    b.onclick = () => { handler(); onchange(key); host.querySelector('[data-option="' + key + '"]')?.focus({preventScroll: true}); };
    g.append(b);
   }
   return g;
  }
  return () => {
   const {style, colours: c, area, disabled} = get();
   const groups = [];
   const logoArea = area === 'logoLeft' || area === 'logoOutline';
   const stripeArea = style === 'stripe' && VA_STRIPE.index(area) >= 0;
   if (logoArea) groups.push(group('Leg logo', [
    ['logo-solid', 'Solid', () => { c.logoStyle = 'solid'; }],
    ['logo-outlined', 'Outlined', () => { c.logoStyle = 'outlined'; }]]));
   if (style === 'ombre' && area === 'panels') groups.push(group('Side panels', [
    ['panels-fade', 'Match the fade', () => { c.panelMode = 'fade'; }],
    ['panels-solid', 'Single colour', () => { c.panelMode = 'solid'; }]]));
   if (stripeArea) {
    groups.push(group('Stripe position', [
     ['stripe-left', 'Left leg', () => { c.stripePlacement = 'left'; }],
     ['stripe-right', 'Right leg', () => { c.stripePlacement = 'right'; }]]));
    groups.push(group('Stripe colours · top to bottom · 1–3', [
     ['stripe-add', 'Add colour', () => { const l = VA_STRIPE.colours(c); if (l.length < VA_STRIPE.max) VA_STRIPE.assign(c, [...l, l[l.length - 1]]); }],
     ['stripe-remove', 'Remove colour', () => { const l = [...VA_STRIPE.colours(c)], i = Math.max(0, VA_STRIPE.index(area)); if (l.length > 1) { l.splice(i, 1); VA_STRIPE.assign(c, l); } }]]));
   }
   host.replaceChildren(...groups); host.hidden = !groups.length;
   const pressed = {
    'logo-solid': c.logoStyle === 'solid', 'logo-outlined': c.logoStyle !== 'solid',
    'panels-fade': c.panelMode !== 'solid', 'panels-solid': c.panelMode === 'solid',
    'stripe-left': c.stripePlacement !== 'right', 'stripe-right': c.stripePlacement === 'right',
   };
   for (const b of host.querySelectorAll('button')) {
    const key = b.dataset.option;
    if (key in pressed) b.setAttribute('aria-pressed', String(pressed[key]));
    b.disabled = !!disabled || (key === 'stripe-add' && VA_STRIPE.colours(c).length >= VA_STRIPE.max) || (key === 'stripe-remove' && VA_STRIPE.colours(c).length <= 1);
   }
  };
 }
};
/* Shared colour-only transfer between the photograph, 3D viewer and enquiry. */
window.VA_DESIGN = (styles, swatches, laceOptions) => {
  const key = 'vision-attire-design-v1';
  const colours = new Set(swatches.map(s => s.hex.toUpperCase()));
  const laces = new Set(laceOptions.filter(l=>l.available).map(l=>l.hex.toUpperCase()));
  const hexList = (list, min, max) => Array.isArray(list) && list.length >= min && list.length <= max
    && list.every(h => typeof h === 'string' && colours.has(h.toUpperCase())) ? list.map(h => h.toUpperCase()) : null;
  const choice = (value, allowed, fallback) => value === undefined ? fallback : allowed.includes(value) ? value : null;
  function normalise(value) {
    if (!value || value.v !== 1 || !styles.some(s => s.id === value.style)
        || !value.designs || typeof value.designs !== 'object') return null;
    if (value.chartReference !== undefined && (typeof value.chartReference !== 'string' || value.chartReference.length > 160)) return null;
    const chartReference = (value.chartReference || '').replace(/[\u0000-\u001F\u007F]/g, '');
    const designs = {};
    for (const style of styles) {
      const input = value.designs[style.id];
      if (!input) continue;
      const out = {};
      for (const zone of [...style.zones, 'laces']) {
        // Parts added after a design was saved (logo outline, 14 Sep) take the style default.
        const raw = input[zone] ?? (zone === 'laces' ? '' : style.defaultColours[zone]);
        const hex = typeof raw === 'string' ? raw.toUpperCase() : '';
        if (!(zone === 'laces' ? laces : colours).has(hex)) return null;
        out[zone] = hex;
      }
      const defaults = style.defaultOptions || {};
      out.logoStyle = choice(input.logoStyle, ['solid', 'outlined'], defaults.logoStyle || 'outlined');
      if (!out.logoStyle) return null;
      if(style.id==='ombre') {
        const clean=hexList(input.gradientStops ?? [out.body,out.side],2,6);
        if(!clean||clean[0]!==out.body||clean[clean.length-1]!==out.side)return null;
        out.gradientStops=clean;
        out.panelMode = choice(input.panelMode, ['fade', 'solid'], defaults.panelMode || 'fade');
        if (!out.panelMode) return null;
      }
      if (style.id === 'stripe') {
        const clean = hexList(input.stripeColours ?? [out.side], 1, 3);
        if (!clean || clean[0] !== out.side) return null;
        out.stripeColours = clean;
        out.stripePlacement = choice(input.stripePlacement, ['left', 'right'], defaults.stripePlacement || 'left');
        if (!out.stripePlacement) return null;
      }
      designs[style.id] = out;
    }
    return designs[value.style] ? { v: 1, style: value.style, designs, chartReference } : null;
  }
  function read(urlHash = location.hash) {
    const hash = new URLSearchParams(urlHash.slice(1));
    try {
      const raw = hash.has('design') ? hash.get('design') : sessionStorage.getItem(key);
      if (!raw) return { value: null, invalid: false };
      const value = raw.length <= 6000 ? normalise(JSON.parse(raw)) : null;
      return { value, invalid: !value };
    } catch { return { value: null, invalid: hash.has('design') }; }
  }
  function save(value) {
    const clean = normalise(value);
    if (clean) try { sessionStorage.setItem(key, JSON.stringify(clean)); } catch {}
    return clean;
  }
  // ponytail: colour selections only; customer details and artwork stay in the form.
  const fragment = value => '#design=' + encodeURIComponent(JSON.stringify(normalise(value)));
  return { normalise, read, save, fragment };
};
